import themes from "../assets/css/theme.json"
export function addColor(shopType) { 
  const {
    green,
    yellow,
    obj = {}
  } = themes;
  if (shopType && shopType == '2') {
    Object.assign(obj, yellow)
  } else {
    Object.assign(obj, green)
  }
  for (let key in obj) {
    document.documentElement.style.setProperty(key, obj[key])
  }

}



// WEBPACK FOOTER //
// ./src/utils/addColor.js